import { render } from "./DateRange.vue?vue&type=template&id=2cbc6a4f&scoped=true"
import script from "./DateRange.vue?vue&type=script&lang=js"
export * from "./DateRange.vue?vue&type=script&lang=js"

import "./DateRange.vue?vue&type=style&index=0&id=2cbc6a4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbc6a4f"]])

export default __exports__